
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Kondhwatomumbaicabservice() {



    const cardData =
    {
        keyword: 'Kondhwa to Mumbai Cab Service',
        heading: 'Meghana Cab : Kondhwa to Mumbai Cab Service',
        headingDescription: 'Meghana Cab offers Kondhwa to Mumbai Cab Service, providing a reliable and comfortable travel solution from Pune’s vibrant residential locality to Mumbai. Whether you’re planning a family trip, business travel, or an airport transfer, our fleet of well-maintained Hatchbacks, Sedans, SUVs, Innova Crysta, and Tempo Travellers caters to every travel need. Enjoy hassle-free door-to-door pickups from Kondhwa, courteous drivers, on-time service, and transparent pricing. Book your Kondhwa to Mumbai Cab with Meghana Cab and experience safe, smooth, and convenient intercity travel with 24/7 customer support.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
   {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

     "services": [
    {
      "name": "Kondhwa to Mumbai Taxi Booking",
      "description": "Book reliable and comfortable taxi services from Kondhwa to Mumbai with easy online reservations. Our cabs are well-maintained, driven by professional chauffeurs, and available round the clock for hassle-free travel."
    },
    {
      "name": "One Way Kondhwa to Mumbai Cab",
      "description": "Choose our one-way cab service from Kondhwa to Mumbai for a convenient, direct trip without worrying about return fares. Perfect for airport transfers, business meetings, or personal travel with fixed pricing."
    },
    {
      "name": "Round Trip Kondhwa to Mumbai Cab",
      "description": "Our round-trip taxi service ensures you have a cab waiting for you on your return journey from Mumbai to Kondhwa, offering flexibility and peace of mind for your travel plans."
    },
    {
      "name": "Online Taxi Kondhwa to Mumbai",
      "description": "Experience the convenience of online taxi booking from Kondhwa to Mumbai. Instant booking confirmation, secure payments, and real-time driver tracking make your travel planning smooth and stress-free."
    },
    {
      "name": "Budget Cab Kondhwa to Mumbai",
      "description": "Travel affordably with our budget-friendly cab options from Kondhwa to Mumbai. Clean, efficient vehicles and transparent pricing make it easy to enjoy quality travel without stretching your budget."
    },
    {
      "name": "AC Sedan Hire Kondhwa to Mumbai",
      "description": "Stay cool and comfortable on your journey with our air-conditioned sedan hire service from Kondhwa to Mumbai. Ideal for solo travelers or small groups seeking a smooth ride on the expressway."
    },
    {
      "name": "SUV Taxi Kondhwa to Mumbai",
      "description": "Opt for our spacious and powerful SUV taxis for travel from Kondhwa to Mumbai. Perfect for families, group trips, or travelers with extra luggage needing extra comfort and space."
    },
    {
      "name": "Reliable Kondhwa to Mumbai Travel Cab",
      "description": "Count on our reliable taxi service from Kondhwa to Mumbai that prioritizes punctuality, safety, and customer satisfaction. Our experienced drivers and well-maintained fleet ensure a smooth journey every time."
    },
    {
      "name": "Chauffeur Cab Kondhwa to Mumbai",
      "description": "Enjoy a professional chauffeur-driven cab experience from Kondhwa to Mumbai. Our courteous and skilled drivers provide safe and comfortable travel tailored to your schedule and preferences."
    },
    {
      "name": "Private Car Kondhwa to Mumbai",
      "description": "Book a private car from Kondhwa to Mumbai for a personalized and exclusive travel experience. Ideal for executives, families, and anyone seeking privacy and flexibility on the road."
    },
    {
      "name": "Corporate Trip Kondhwa to Mumbai Taxi",
      "description": "Facilitate seamless corporate travel between Kondhwa and Mumbai with our dedicated business taxi services, including GST billing, timely pickups, and comfortable rides suited for professionals."
    },
    {
      "name": "Long Distance Kondhwa to Mumbai Cab",
      "description": "Our long-distance cab service from Kondhwa to Mumbai guarantees comfort and safety over the highway journey, with vehicles equipped for extended travel and drivers experienced in intercity routes."
    },
    {
      "name": "Family Cab Kondhwa to Mumbai Route",
      "description": "Travel with your family comfortably using our family-friendly cabs from Kondhwa to Mumbai. Spacious interiors and attentive drivers make the trip safe and enjoyable for all ages."
    },
    {
      "name": "Fast Booking Kondhwa to Mumbai Taxi",
      "description": "Get instant and hassle-free cab booking from Kondhwa to Mumbai with our fast online reservation system, ensuring quick confirmations and timely pickups."
    },
    {
      "name": "24/7 Cab Service Kondhwa to Mumbai",
      "description": "Avail our round-the-clock cab services from Kondhwa to Mumbai, perfect for early morning flights, late-night meetings, or anytime travel with dependable availability."
    }
  ],
  "tableData": [
    ["Kondhwa to Mumbai Taxi Booking", "One Way Kondhwa to Mumbai Cab"],
    ["Round Trip Kondhwa to Mumbai Cab", "Online Taxi Kondhwa to Mumbai"],
    ["Budget Cab Kondhwa to Mumbai", "AC Sedan Hire Kondhwa to Mumbai"],
    ["SUV Taxi Kondhwa to Mumbai", "Reliable Kondhwa to Mumbai Travel Cab"],
    ["Chauffeur Cab Kondhwa to Mumbai", "Private Car Kondhwa to Mumbai"],
    ["Corporate Trip Kondhwa to Mumbai Taxi", "Long Distance Kondhwa to Mumbai Cab"],
    ["Family Cab Kondhwa to Mumbai Route", "Fast Booking Kondhwa to Mumbai Taxi"],
    ["24/7 Cab Service Kondhwa to Mumbai", ""]
  ],




"whychoose": [
    {
        "WhyChooseheading": "Reliable Kondhwa to Mumbai Cab Service for Stress-Free Travel",
        "WhyChoosedescription": "Our Kondhwa to Mumbai cab service guarantees punctual pickups and safe, comfortable rides. Whether you’re commuting for work, heading to the airport, or traveling for leisure, our service is designed to provide you with a hassle-free and enjoyable journey every time."
    },
    {
        "WhyChooseheading": "Clean, Spacious, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in our air-conditioned, meticulously maintained cabs that offer ample legroom and luggage space. We prioritize vehicle hygiene and comfort, ensuring that every ride is pleasant regardless of the distance or duration."
    },
    {
        "WhyChooseheading": "Professional, Experienced, and Friendly Drivers",
        "WhyChoosedescription": "Our drivers are background-verified and extensively trained to offer courteous, safe, and efficient service. Familiar with the Kondhwa to Mumbai route and alternative paths, they ensure timely arrivals and smooth journeys, adapting to traffic conditions effectively."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
        "WhyChoosedescription": "We provide clear and competitive fare estimates that include all charges such as tolls, fuel, taxes, and driver allowances. Our transparent pricing model ensures peace of mind with no unexpected fees or additional costs."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Customized to Your Needs",
        "WhyChoosedescription": "Whether you require a one-way trip, round-trip, or hourly cab rental, we offer flexible plans tailored to your schedule. Customize your pickup and drop-off points anywhere within Kondhwa and Mumbai, and travel on your terms."
    },
    {
        "WhyChooseheading": "Convenient Door-to-Door Pickup and Drop-off",
        "WhyChoosedescription": "Experience the ease of direct pickups and drop-offs at your preferred locations—be it your home, office, or hotel. This door-to-door service saves you time and effort, enhancing your overall travel experience."
    },
    {
        "WhyChooseheading": "Perfect for Airport Transfers, Corporate Travel, and Family Outings",
        "WhyChoosedescription": "Whether you're heading to Mumbai International Airport, attending business meetings, or traveling with family and friends, our cabs cater to all travel requirements with comfort and professionalism."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Hassle-Free Booking",
        "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist you with bookings, cancellations, and any special travel requests. Book your Kondhwa to Mumbai cab anytime, knowing that support is always just a call or click away."
    }
]





















    }

const faqData = [
    {
        question: "How can I book a cab from Kondhwa to Mumbai?",
        answer: "Booking is simple—call Meghana Cab at +91 9075462128 or book online through our website for instant confirmation."
    },
    {
        question: "What is the average travel time from Kondhwa to Mumbai by cab?",
        answer: "The journey usually takes around 3.5 to 4.5 hours depending on traffic and pickup time."
    },
    {
        question: "Are both one way and round trip options available from Kondhwa to Mumbai?",
        answer: "Yes, we provide flexible booking options including both one way and round trip services."
    },
    {
        question: "What types of vehicles are available for Kondhwa to Mumbai cab booking?",
        answer: "You can choose from hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers based on your needs."
    },
    {
        question: "Is the cab service from Kondhwa to Mumbai available 24/7?",
        answer: "Yes, Meghana Cab operates round the clock to accommodate your schedule any time of day or night."
    },
    {
        question: "What does the fare include for this route?",
        answer: "The fare includes fuel, tolls, and driver charges. Any additional parking or waiting fees may be charged separately."
    },
    {
        question: "Can I book a cab on short notice from Kondhwa to Mumbai?",
        answer: "Yes, we accept last-minute bookings based on vehicle availability. For urgent travel, please call us directly."
    },
    {
        question: "Is online booking available for Kondhwa to Mumbai cab service?",
        answer: "Yes, you can conveniently book online 24/7 through our secure booking platform."
    },
    {
        question: "Can I request stopovers for meals or breaks during the trip?",
        answer: "Yes, you can request short stops during the ride. Please inform us in advance or let the driver know."
    },
    {
        question: "Are your drivers familiar with the Kondhwa to Mumbai route?",
        answer: "Absolutely. All our drivers are trained, experienced, and well-acquainted with the best routes to ensure a safe and timely journey."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Sameer Khan',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent cab service from Kondhwa to Mumbai. The driver was punctual, and the journey was smooth and comfortable.”',
    },
    {
        name: 'Ms. Rutuja Patankar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Clean car, polite driver, and reliable service. Booking from Kondhwa to Mumbai was quick and easy.”',
    },
];





























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kondhwa to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/kondhwa-to-mumbai-cab.jpg",
  "description": "Reliable cab service from Kondhwa to Mumbai with Meghana Cabs. Choose from budget, AC sedan, and SUV taxis for one-way or round trips. Chauffeur-driven and family-friendly options available. Book online 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1900",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/kondhwa-to-mumbai-cab-service"
  }
};








    return (
        <div>

<Helmet>
  <title>Kondhwa to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book reliable Kondhwa to Mumbai cab service with Meghana Cabs. Budget, AC sedan, and SUV taxis available for one-way and round trips. Chauffeur-driven and family travel options. Online booking 24/7." 
  />
  <meta 
    name="keywords" 
    content="Kondhwa to Mumbai Taxi Booking, One Way Kondhwa to Mumbai Cab, Round Trip Kondhwa to Mumbai Cab, Online Taxi Kondhwa to Mumbai, Budget Cab Kondhwa to Mumbai, AC Sedan Hire Kondhwa to Mumbai, SUV Taxi Kondhwa to Mumbai, Reliable Kondhwa to Mumbai Travel Cab, Chauffeur Cab Kondhwa to Mumbai, Private Car Kondhwa to Mumbai, Corporate Trip Kondhwa to Mumbai Taxi, Long Distance Kondhwa to Mumbai Cab, Family Cab Kondhwa to Mumbai Route, Fast Booking Kondhwa to Mumbai Taxi, 24/7 Cab Service Kondhwa to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/62.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kondhwatomumbaicabservice;